import { useState, useEffect, useRef, useCallback } from 'react';

export default (rootMargin = 0) => {
  const [isSticky, setSticky] = useState(false);
  const [offsetTop, setOffsetTop] = useState(0);

  const element = useRef(null);

  const handleScroll = useCallback(() => {
    setSticky(window.scrollY > offsetTop - rootMargin);
  }, [offsetTop, rootMargin]);

  useEffect(() => {
    if (element.current)
      setOffsetTop(element.current.offsetTop + element.current.offsetHeight);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [handleScroll]);

  return { isSticky, element };
};



// WEBPACK FOOTER //
// ./app/containers/Premium/hooks/useSticky.js